import { css } from 'linaria';

export const productCard = css`
  display: flex;
  width: 100%;
  margin-bottom: 56px;

  @media (--only-largeDesktop) {
    column-gap: 48px;
  }

  @media (--only-desktop) {
    column-gap: 40px;
  }

  @media (--to-desktop) {
    flex-direction: column;
  }

  @media (--only-tablet) {
    row-gap: 40px;
  }

  @media (--only-mobile) {
    row-gap: 16px;
    margin-bottom: 40px;
  }
`;
